<template>
    <TasksListComponent :title="$t('taskViews.unfinished')" :apiUrl="apiUrl" :showFilters="false" />
</template>
  
<script>
import TasksListComponent from '@/components/TasksListComponent.vue';

export default {
    name: 'TasksUnfinishedListView',
    components: {
        TasksListComponent
    },
    computed: {
        apiUrl() {
            const baseApiUrl = 'tasks/';
            const params = new URLSearchParams({
                finished: '0',
                users: this.currentUser.id,
                sort_by: 'estimated_date',
                sort_order: 'asc'
            });
            if (this.$route.query.project_id) {
                params.append('project_id', this.$route.query.project_id);
            }
            if (this.$route.query.priority_id) {
                params.append('priority_id', this.$route.query.priority_id);
            }
            return `${baseApiUrl}?${params.toString()}`;
        },
        currentUser() {
            const user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        }
    }
};
</script>
  